import ApiService from '@/services/api.service';

const state = {
    refCode: [],
    errors: {},
    success: {}
};

const getters = {
    refCode: state => state.refCode,
}

const actions = {
    postSendRefCode(context, refCode) {
        return ApiService.post('send_ref_code/', { ref_code: refCode })
            .then((response) => {
                context.commit('SET_REF_CODE', refCode);
                context.commit('SET_ERROR', {});
                context.commit('SET_SUCCESS', response.data);
                console.log(response.data);
            })
            .catch((error) => {
                context.commit('SET_ERROR', error.response.data);
                throw new Error('Something went wrong');
            });
    },
};


const mutations = {
    SET_REF_CODE(state, payload) {
        state.refCode = payload;
    },
    SET_ERROR(state, error) {
        state.errors = error;
    },
    SET_SUCCESS(state, success) {
        state.success = success;
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
